var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pop-up"},[_c('div',{staticClass:"w-full sm:w-1/2 lg:w-2/3"},[_c('img',{attrs:{"src":"/img/surveySubmitted.png","alt":""}})])])])
}]

export { render, staticRenderFns }